import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

/**
 * Pills synthesized from an artifact moniker (or a metadata pill the same moniker names) whose
 * rows still live on the artifact. Legacy count-only list pills are not in this set, so a miss
 * on `Artifacts.list` cannot turn them into unavailable chips.
 */
const artifactHydrationPills = new WeakSet<WorkspaceAgentMessagePill>();

export const markWorkspaceAgentArtifactHydrationPill = (pill: WorkspaceAgentMessagePill): void => {
  artifactHydrationPills.add(pill);
};

export const isWorkspaceAgentArtifactHydrationPill = (pill: WorkspaceAgentMessagePill): boolean =>
  artifactHydrationPills.has(pill);

export const workspaceAgentArtifactPillNeedsRowHydration = (pill: WorkspaceAgentMessagePill): boolean => {
  if (pill.type === 'assetList' || pill.type === 'boardList') {
    return pill.items === undefined;
  }

  return (pill.type === 'changePreview' || pill.type === 'table') && pill.rows.length === 0;
};
